import getInitial from 'owa-persona/lib/utils/getInitial';
import getTextBoyColor from 'owa-persona/lib/utils/getTextBoyColor';
import {
    LocationPersonaControlViewState,
    LocationSelectionSource,
} from '../data/schema/LocationPersonaControlViewState';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

/**
 * Create location persona specifically for a room selected using a room picker
 * @param roomName: name of the room
 * @param roomEmail: email adddress of the room resource
 */
export function createLocationPersonaFromRoomInfo(
    roomName: string,
    roomEmail: string,
    selectionSource?: LocationSelectionSource
): LocationPersonaControlViewState {
    let wrappedEmail: EmailAddressWrapper = {
        EmailAddress: roomEmail,
    };

    return {
        personaId: roomEmail,
        displayName: roomName,
        postalAddress: {
            LocationSource: 'Resource',
            LocationUri: roomEmail,
            Type: 'Business',
        },
        displayAddress: '',
        initials: getInitial(roomName),
        textBoyColor: getTextBoyColor(roomName),
        selectionSource: selectionSource,
        personaType: 'Room',
        personaControlId: roomName,
        emailAddress: wrappedEmail,
    };
}
